import React from 'react'

const MissionSubmitStatus = ({mission, teams}) => {
  return (
    <div className='rounded-lg border bg-white p-4 m-3 mb-6'>
        <h2 className='text-lg mb-2 text-purple-600'>提出状況</h2>

        <div className='grid grid-cols-1 gap-2'>
            {mission.reports && Object.keys(mission.reports).map((key) => {
                return (
                    <div key={key} className='flex justify-between items-center p-2 rounded-lg border bg-white'>
                        <div className='text-gray-800'><i className='bi bi-people-fill mx-1' style={{color: teams[key]?.color}}></i>{teams[key]?.name}</div>
                        <div className='text-gray-500 text-base'><i className='bi bi-check-lg me-1 text-green-700 text-base'></i>{new Date(mission.reports[key]?.time).toLocaleTimeString()}</div>
                    </div>
                )
            })}
        </div>

        {/* 未提出チーム */}
        <div className='mt-4'>
            <h3 className='text-base text-gray-600 mb-2'>未提出チーム</h3>
            <div className='grid grid-cols-2 gap-4'>
                {teams && teams.map((team) => {
                    if(!mission.reports || !mission.reports[team.id]) {
                        return (
                            <div key={team.id} className='text-gray-800 text-sm'><i className='bi bi-people-fill mx-1' style={{color: team?.color}}></i>{team?.name}</div>
                        )
                    }
                    return null;
                })}

                {/* ない場合 */}
                {(mission.reports && Object.keys(mission.reports).length === Object.keys(teams).length) && (
                    <div className='text-gray-500 text-sm text-center col-span-2'>全チーム提出済み</div>
                )}
            </div>
        </div>
    </div>
)
}

export default MissionSubmitStatus